import * as Common from '@/tenant/common';

export class SendPaymentResultReportQuery extends Common.Query {
    constructor(){
        super("SendPaymentResultReportQuery", null);
    }
    public templateId:number=0;
    public segment: Common.Segment = null;
    public counterpart: Common.Counterpart = null;
    public bankAccount: Common.BankAccount = null;
    public startDate: Date = null;
    public endDate: Date = null;
    public onExcelExport:boolean = false;           
}

export class SendPaymentResultReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='SendPaymentResultReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}